import { Component, OnInit } from '@angular/core';
//import { FormGroup, FormControl } from "@angular/forms";
import { Title } from '@angular/platform-browser';
import { MuestraService } from "../../../modulo-comunes/servicios/muestra-servicios";
import { LogService } from "../../../modulo-comunes/servicios/log-servicios";
import { DataEmpresaService } from '../../../modulo-comunes/servicios/data-empresa-servicios';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {
  sitio: string = 'EasyMed';
  constructor(
    private titleService: Title,
    private muestraService: MuestraService,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService
  ) {
    this.sitio = this.dataEmpresaService.sitioElegido;
  }

  ngOnInit() {
    this.titleService.setTitle(this.sitio);
  }
}
